// packages/web/src/api/lodging-declarations/keys.ts

export const lodgingKeys = {
  all: ["lodging-declarations"] as const,
  inbox: (userId: string) => [...lodgingKeys.all, "inbox", userId] as const,
  detail: (id: string) => [...lodgingKeys.all, id] as const,
};
